export type ShareChannel =
	| 'facebook'
	| 'facebookMessenger'
	| 'twitter'
	| 'whatsapp'
	| 'instagram'
	| 'instagramStories'
	| 'tiktok'
	| 'vk'
	| 'line'
	| 'nextdoor'
	| 'email'
	| 'sms'
	| 'copy'
	| 'mobileNativeShare'
	| 'reddit';

/**
 * Configuration for the share actions.
 * All props need to be optional to allow for flexibility in usage.
 */
export type ShareConfig = {
	instagramStories?: {
		enabled: boolean;
	};
	tiktok?: {
		enabled: boolean;
	};
	facebook?: { mode: { mobile: 'sdk' | 'url'; desktop: 'sdk' | 'url' } };
	mobileNativeShare?: { trackIntent?: boolean };
};

/**
 * Opt in to `share_petition_intent`-style tracking for the `mobileNativeShare` channel.
 * Shared so the petition-share touchpoints that opt in (see CHANGE-95044) stay in sync.
 */
export const TRACK_NATIVE_SHARE_INTENT: NonNullable<ShareConfig['mobileNativeShare']> = { trackIntent: true };
